export default {
  "root": "_root_ob76a_1",
  "--type-literal": "_--type-literal_ob76a_1",
  "--type-unit": "_--type-unit_ob76a_1",
  "--type-literal--m": "_--type-literal--m_ob76a_1",
  "--type-unit--m": "_--type-unit--m_ob76a_1",
  "--type-literal--l": "_--type-literal--l_ob76a_1",
  "--type-unit--l": "_--type-unit--l_ob76a_1",
  "--type-literal--xl": "_--type-literal--xl_ob76a_1",
  "--type-unit--xl": "_--type-unit--xl_ob76a_1"
};import "ni:sha-256;t6hu1Sav0r4pcEB4yHIEzUAaDqqf3BN4wMFWS0DAM9s";